import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'src/components/atoms/Button';

type FooterProps = {
  onCancelClick: () => void;
};

export const Footer: React.FC<FooterProps> = ({ onCancelClick }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Flex justifyContent="flex-end" gap={3} mt={6}>
      <Button
        buttonName="cancel-forecast"
        variant="outline"
        onClick={onCancelClick}>
        Cancel
      </Button>
      <Button
        buttonName="create-forecast-submit"
        variant="primary"
        type="submit"
        isLoading={isSubmitting}>
        Create Forecast
      </Button>
    </Flex>
  );
};
